module.exports = __webpack_public_path__ + "img/13.88fc82b9.png";